import styled from 'styled-components';
import WindowSize from '../../services/WindowSize';
const { mobile } = WindowSize;

export default styled.div`
  min-height: ${mobile ? 'calc(100% + 2px)' : '100%'};
  min-width: 100%;
`;